@if (hierarchy(); as hierarchy) {
  <div class="hierarchy">
    <div class="hierarchy__division">
      <procure-tag>
        {{ hierarchy.division?.getDisplay() }}
      </procure-tag>
    </div>
    <div class="hierarchy__hub">
      <procure-tag>
        {{ hierarchy.hub?.getDisplay() }}
      </procure-tag>
      <div class="hierarchy__tree-indicator">
        <div class="hierarchy__vertical-line"></div>
        <div class="hierarchy__horizontal-line"></div>
      </div>
    </div>
  </div>
} @else {
  -
}
